import { avatarFor } from '@/utils/avatar';

/**
 * v3.19 自媒体：预置头像圆块（emoji + 背景色）。
 * 依据 did 确定性分配，未设置本机头像时同一作者处处一致。
 */
export function AvatarChip({
  did,
  name,
  size = 'md',
}: {
  did: string;
  name?: string;
  size?: 'sm' | 'md' | 'lg';
}): JSX.Element {
  const av = avatarFor(did || name || 'u');
  const cls =
    size === 'sm'
      ? 'h-7 w-7 rounded-full text-sm'
      : size === 'lg'
        ? 'h-16 w-16 rounded-full text-3xl'
        : 'h-10 w-10 rounded-full text-xl';
  return (
    <span
      aria-hidden
      className={`flex shrink-0 items-center justify-center ${cls}`}
      style={{ backgroundColor: av.bg }}
    >
      {av.emoji}
    </span>
  );
}
